import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './MaterialSelcet.scss';
import Select from 'react-select';

MaterialSelcet.propTypes = {
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    isSearchable: PropTypes.bool,
    errorMsg: PropTypes.string,
    defaultClassName: PropTypes.string,
    placeholder: PropTypes.string,
    menuIsOpen: PropTypes.bool,
    onInputChange: PropTypes.func,
    onMenuScrollToBottom: PropTypes.func
};

function MaterialSelcet({
    label,
    options,
    value,
    onChange,
    error,
    isLoading,
    isDisabled,
    isClearable,
    isMulti,
    isSearchable,
    errorMsg,
    defaultClassName,
    placeholder,
    menuIsOpen,
    onInputChange,
    onMenuScrollToBottom
}) {
    const [focusValue, setFocusValue] = useState(false);

    const handleFocus = () => {
        setFocusValue(true);
    };

    const handleBlur = () => {
        setFocusValue(false);
    };

    const getClassName = () => {
        let className = `matSelection__label ${defaultClassName ? defaultClassName + '-label' : ''}`;

        if (!value) {
            if (focusValue) {
                className = className + ' matSelection__label--active';
            }
        } else {
            className = className + ' matSelection__label--active';
        }

        if (error) {
            className = className + ' matSelection__label--error';
        }

        return className;
    };

    return (<div className={`matSelection ${defaultClassName || ''}`}>
        {label !== '' && <label className={getClassName()}>{label}</label>}
        <Select
            menuIsOpen={menuIsOpen}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={placeholder || ''}
            isLoading={isLoading}
            isDisabled={isDisabled}
            isClearable={isClearable}
            isMulti={isMulti}
            isSearchable={isSearchable}
            onInputChange={onInputChange}
            onMenuScrollToBottom={onMenuScrollToBottom}
            value={value}
            onChange={onChange}
            options={options}
            className={!error ? `matSelection__select ${defaultClassName ? defaultClassName + '-selection' : ''}` : `matSelection__select matSelection__select--error ${defaultClassName ? defaultClassName + '-selection' : ''}`}
            classNamePrefix={'selection'}/>
        {error && <div className={`matSelection__error ${defaultClassName ? defaultClassName + 'error' : ''}`}>{errorMsg}</div>}
    </div>);
}

export default MaterialSelcet;
